export default __webpack_public_path__ + "static/media/discussion.02ba0eb1.svg";